enum ControleReclamacaoStatus {
    Aberto = 0,
    Processo = 1,
    Finalizado = 2,
}

export default ControleReclamacaoStatus;
